import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonAction, FileView, RowActionEvent } from '../../models';
import { MatProgressBar } from '@angular/material/progress-bar';
import { DecimalPipe, NgIf } from '@angular/common';

@Component({
    selector: '[file-loaded]',
    templateUrl: './file.component.html',
    styleUrls: ['./file.component.scss'],
    imports: [MatProgressBar, NgIf, DecimalPipe],
    standalone: true,
})
export class FileComponent {
    @Input() fileView: FileView;
    @Input() disableAllButtonsRow: boolean;
    @Input() loadSuccess?: boolean;
    @Output() rowFileClicked: EventEmitter<RowActionEvent> = new EventEmitter();

    typeButton = ButtonAction;

    rowClicked(btn: ButtonAction) {
        let event: RowActionEvent = {
            action: btn,
        };
        this.rowFileClicked.emit(event);
    }
}
